import z from "zod"
import {
	DEGREE_FIELD,
	DEGREE_NAME,
	DISABILITY_ENUM,
	GENDER,
	JOB_TYPE,
	LEVEL,
	MARITAL_STATUS,
	ORGANIZATION_SECTOR,
	ORGANIZATION_SIZE,
	TIMINGS,
} from "./enums"
import cities from "../cities"

export const email = () => z.email("@q:invalid_email").toLowerCase()
export const password = () =>
	z.string().min(8, "@q:password_too_short").max(64, "@q:password_too_long")
export const phone = () =>
	z.string("@q:invalid_phone").toLowerCase().min(10, "@q:invalid_phone")
export const neighborhood = () => z.string().min(1, "@q:invalid_neighborhood")
export const organizationSize = () =>
	z.enum(ORGANIZATION_SIZE, { error: "@q:invalid_organization_size" })
export const organizationSector = () =>
	z.enum(ORGANIZATION_SECTOR, { error: "@q:invalid_organization_sector" })

export const bool = () => z.boolean({ error: "@q:invalid_boolean" })

export const city = () => z.enum(cities, { error: "@q:invalid_city" })
export const USERNAME_REGEX = /^[a-z0-9][a-z0-9_.]*$/
export const username = () =>
	z
		.string()
		.trim()
		.toLowerCase()
		.min(3, "@q:username_too_short")
		.max(30, "@q:username_too_long")
		.regex(USERNAME_REGEX, "@q:invalid_username_format")
export const name = () =>
	z.string().trim().min(1, "@q:invalid_name").max(64, "@q:invalid_name")

export const turnstile_token = () =>
	z.string().trim().min(1, "@q:invalid_turnstile_token")

export const age = () =>
	z.number().min(17, "@q:invalid_age").max(99, "@q:invalid_age")

export function gender<T extends boolean>(
	allowBoth: T = false as T
): T extends true
	? z.ZodEnum<{ male: "male"; female: "female"; both: "both" }>
	: z.ZodEnum<{ male: "male"; female: "female" }> {
	return z.enum(allowBoth ? [...GENDER, "both"] : GENDER, {
		error: "@q:invalid_gender",
	})
}

export const maritalStatus = () =>
	z.enum(MARITAL_STATUS, { error: "@q:invalid_marital_status" })

export const hearAbout = () => z.string().min(1, "@q:invalid_hear_about")

export const disability = () =>
	z.enum(DISABILITY_ENUM, { error: "@q:invalid_disability" })

export const jobType = () => z.enum(JOB_TYPE, { error: "@q:invalid_job_type" })

export const level = () => z.enum(LEVEL, { error: "@q:invalid_level" })

export const degreeName = () =>
	z.enum(DEGREE_NAME, { error: "@q:invalid_degree" })
export const degreeField = () =>
	z.enum(DEGREE_FIELD, { error: "@q:invalid_degree_field" })

export const previousExperience = () =>
	z
		.object({
			organizationName: z.string().min(1, "@q:invalid_organization_name"),
			previousRole: z.string().min(1, "@q:invalid_previous_role"),
			lastSalary: z.number().min(0, "@q:invalid_last_salary"),
			year: z.number().int().min(1, "@q:invalid_year"),
		})
		.optional()

export const title = () =>
	z.string().min(1, "@q:invalid_title").max(128, "@q:invalid_title")

export const description = () =>
	z
		.string()
		.min(1, "@q:invalid_description")
		.max(1512, "@q:invalid_description")

export const timings = () => z.enum(TIMINGS, { error: "@q:invalid_timings" })

export const fieldOfWork = () => z.string().min(1, "@q:invalid_field_of_work")

export const hours = () => z.number().min(1).max(12, "@q:invalid_hours")
export const weeklyRestDays = () =>
	z.number().min(1).max(7, "@q:invalid_weekly_rest_days")

export const salary = () => z.number().min(1, "@q:invalid_salary")

export const medicalInsurance = () =>
	z.string().min(1, "@q:invalid_medical_insurance")

export const capacity = () => z.number().min(1, "@q:invalid_capacity")

export const specialization = () =>
	z.string().min(1, "@q:invalid_specialization")

export const housingAllowance = () =>
	z.number().min(0, "@q:invalid_housing_allowance")
export const anotherAllowance = () =>
	z.number().min(0, "@q:invalid_another_allowance")

export const extra = () => z.string().min(1, "@q:invalid_extra")
